import { render, staticRenderFns } from "./storeMarketingStat.vue?vue&type=template&id=ea80a3c0&"
import script from "./storeMarketingStat.vue?vue&type=script&lang=js&"
export * from "./storeMarketingStat.vue?vue&type=script&lang=js&"
import style0 from "./storeMarketingStat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports